import React, { forwardRef } from 'react';
import {
  TextInput as RNTextInput,
  type TextInputProps as RNTextInputProps,
} from 'react-native';

import { FONT_SCALE_CAP, type TextScale } from './fontScale';

export type TextInputProps = RNTextInputProps & {
  /** Which font-scale cap applies. Defaults to `chrome` (1.5x). */
  scale?: TextScale;
};

/** Instance type, so `useRef<TextInput>` keeps meaning the native handle. */
export type TextInput = RNTextInput;

/**
 * The app's TextInput. Identical to react-native's TextInput except that OS
 * font scaling is capped per `scale` (an explicit `maxFontSizeMultiplier`
 * wins). Import from '@/components/common/text', never from 'react-native'.
 */
export const TextInput = forwardRef<RNTextInput, TextInputProps>(function TextInput(
  { scale = 'chrome', maxFontSizeMultiplier, ...rest },
  ref,
) {
  return (
    <RNTextInput
      ref={ref}
      maxFontSizeMultiplier={maxFontSizeMultiplier ?? FONT_SCALE_CAP[scale]}
      {...rest}
    />
  );
});
